import { render, staticRenderFns } from "./ModalHeaderNew.vue?vue&type=template&id=c2113110"
import script from "./ModalHeaderNew.vue?vue&type=script&lang=ts"
export * from "./ModalHeaderNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2113110')) {
      api.createRecord('c2113110', component.options)
    } else {
      api.reload('c2113110', component.options)
    }
    module.hot.accept("./ModalHeaderNew.vue?vue&type=template&id=c2113110", function () {
      api.rerender('c2113110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/ModalHeaderNew.vue"
export default component.exports